import React, { Fragment, useState } from 'react';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import Modal from 'chameleon/ui-stack/ui/base/modal';
import AutocompleteSelect from 'chameleon/ui-stack/ui/forms/autocomplete-select';
import DatePickerWrapper from '../Filters/components/DatePickerWrapper';
import Checkbox from 'legacy/src/components/Checkbox';
import Button from 'chameleon/ui-stack/ui/base/button';

import './index.scss';

export const assessmentTypes = [
  { label: 'All', value: 'all' },
  { label: 'Progress Checks', value: 'ppc' },
  { label: 'My Quizzes', value: 'qb' },
  { label: 'Practice Exam', value: 'pe' },
];

const FiltersWithPopover = (props) => {
  const {
    dateFrom,
    setDateTo,
    setDateFrom,
    isStudent,
    dateTo,
    router,
    updateAssessmentTypeParams,
    checkedItems,
    setCheckedItems,
    applyFilters,
  } = props;
  const {
    location: {
      query: { type: assessmentTypeParam },
    },
  } = router;
  const [isOpen, setIsOpen] = useState(false);
  const [checkedItemsLocal, setCheckedItemsLocal] = useState(checkedItems);
  const [dateFromLocal, setDateFromLocal] = useState(dateFrom);
  const [dateToLocal, setDateToLocal] = useState(dateTo);
  const [assessmentType, setAssessmentType] = useState(assessmentTypeParam);

  const setAssessmentTypeValue = () =>
    assessmentTypes.find(({ value }) =>
      !!assessmentType ? value === assessmentType : value === 'all',
    );
  const handleApply = () => {
    setDateTo(dateToLocal);
    setDateFrom(dateFromLocal);
    updateAssessmentTypeParams(assessmentType);
    setCheckedItems(checkedItemsLocal);
    setIsOpen(false);
    applyFilters();
  };

  const handleCancel = () => {
    setDateToLocal(dateTo);
    setDateFromLocal(dateFrom);
    setAssessmentType(assessmentTypeParam);
    setCheckedItemsLocal(checkedItems);
    setIsOpen(false);
  };
  return (
    <Fragment>
      <button
        className="filter-button border border-solid border-gray-400 bg-white text-gray-900"
        onClick={() => setIsOpen(true)}
      >
        Filters
        <Icon id="more_filters" />
      </button>
      {isOpen && (
        <Modal size="full" onClose={() => setIsOpen(false)} title="Filters">
          <div className="grid content-between h-full">
            <div className="grid gap-6 text-gray-600 py-10">
              <div>Submit Date Range</div>
              <div className="flex items-center gap-4">
                <DatePickerWrapper
                  defaultValue={dateFromLocal}
                  onChange={(value) => {
                    if (value !== dateFromLocal) {
                      setDateFromLocal(value);
                    }
                  }}
                  minDate={isStudent ? dateFrom : null}
                  trackingId="date-from-selector"
                />
                <div>to</div>
                <DatePickerWrapper
                  defaultValue={dateToLocal}
                  onChange={(value) => {
                    if (value !== dateToLocal) {
                      setDateToLocal(value);
                    }
                  }}
                  minDate={isStudent ? dateFrom : null}
                  trackingId="date-to-selector"
                />
              </div>
              <div>Assessment Type</div>
              <AutocompleteSelect
                options={assessmentTypes}
                onChange={({ value }) => {
                  setAssessmentType(value);
                }}
                value={setAssessmentTypeValue()}
                trackingId="assessment-type-selector"
              />

              <div className="performance-filters-container grid gap-y-5">
                <div className="performance-filters-header">
                  Average Cumulative Performance
                </div>
                <div className="performance-filters-body z-0">
                  <div className="quartile-container">
                    <Checkbox
                      backgroundColor="#1E1E1E"
                      width={22}
                      height={22}
                      onClick={() => {
                        setCheckedItemsLocal({
                          ...checkedItemsLocal,
                          notAssessed: !checkedItemsLocal.notAssessed,
                        });
                      }}
                      checked={checkedItemsLocal.notAssessed}
                    />
                    <div
                      role="img"
                      aria-label="Not assessed"
                      className="quartile-indicator quartile-indicator--not-assessed"
                    />
                    <span>Not Assessed</span>
                  </div>
                  <div className="quartile-container">
                    <Checkbox
                      backgroundColor="#1E1E1E"
                      width={22}
                      height={22}
                      onClick={() => {
                        setCheckedItemsLocal({
                          ...checkedItemsLocal,
                          firstQuartile: !checkedItemsLocal.firstQuartile,
                        });
                      }}
                      checked={checkedItemsLocal.firstQuartile}
                    />
                    <div
                      role="img"
                      aria-label="0 - 24.99%"
                      className="quartile-indicator quartile-indicator--first"
                    />
                    <span>0 - 24.99%</span>
                  </div>
                  <div className="quartile-container">
                    <Checkbox
                      backgroundColor="#1E1E1E"
                      width={22}
                      height={22}
                      onClick={() => {
                        setCheckedItemsLocal({
                          ...checkedItemsLocal,
                          secondQuartile: !checkedItemsLocal.secondQuartile,
                        });
                      }}
                      checked={checkedItemsLocal.secondQuartile}
                    />
                    <div
                      role="img"
                      aria-label="25 to 49.99%"
                      className="quartile-indicator quartile-indicator--second"
                    />
                    <span>25 - 49.99%</span>
                  </div>
                  <div className="quartile-container">
                    <Checkbox
                      backgroundColor="#1E1E1E"
                      width={22}
                      height={22}
                      onClick={() => {
                        setCheckedItemsLocal({
                          ...checkedItemsLocal,
                          thirdQuartile: !checkedItemsLocal.thirdQuartile,
                        });
                      }}
                      checked={checkedItemsLocal.thirdQuartile}
                    />
                    <div
                      role="img"
                      aria-label="50 to 74.99%"
                      className="quartile-indicator quartile-indicator--third"
                    />
                    <span>50 - 74.99%</span>
                  </div>
                  <div className="quartile-container">
                    <Checkbox
                      backgroundColor="#1E1E1E"
                      width={22}
                      height={22}
                      onClick={() => {
                        setCheckedItemsLocal({
                          ...checkedItemsLocal,
                          fourthQuartile: !checkedItemsLocal.fourthQuartile,
                        });
                      }}
                      checked={checkedItemsLocal.fourthQuartile}
                    />
                    <div
                      role="img"
                      aria-label="75 to 100%"
                      className="quartile-indicator quartile-indicator--fourth"
                    />
                    <span>75 - 100%</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="button-wrapper flex items-center justify-end gap-3">
              <hr />
              <Button onClick={handleCancel} isNaked>
                Cancel
              </Button>
              <Button onClick={() => handleApply()} isPrimary>
                Apply
              </Button>
            </div>
          </div>
        </Modal>
      )}
    </Fragment>
  );
};

export default FiltersWithPopover;
